import { render } from "./OuterItemPage.vue?vue&type=template&id=4c543609&scoped=true&ts=true"
import script from "./OuterItemPage.vue?vue&type=script&lang=ts"
export * from "./OuterItemPage.vue?vue&type=script&lang=ts"

import "./OuterItemPage.vue?vue&type=style&index=0&id=4c543609&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c543609"]])

export default __exports__